// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r6-0";
export var leftAlign = "_r6-4";
export var listItem = "_r6-2";
export var listItemWrapper = "_r6-1";
export var operationText = "_r6-3";